import { useEffect } from 'react'
import { applyAnchorLocks } from '../validation/locks'
import { useScheduleActions } from './useScheduleActions'

const lockSignature = targeting =>
  (targeting || [])
    .filter(row => row.lockedByAnchor)
    .map(row => `${row.attribute}:${row.value}`)
    .join('|')

/** Keep Arm/Phase rows in sync with pinning anchors while editing. */
export const useLiveAnchorLocks = (schedule, entityOptions) => {
  const { updateSchedule } = useScheduleActions()
  const anchorKey = JSON.stringify(
    (schedule.anchors || []).map(anchor => ({
      type: anchor.type,
      instanceId: anchor.instanceId,
      instanceIds: anchor.instanceIds,
    })),
  )

  useEffect(() => {
    const next = applyAnchorLocks(schedule, entityOptions, null)
    if (lockSignature(next.targeting) !== lockSignature(schedule.targeting)) {
      updateSchedule(schedule.id, { targeting: next.targeting })
    }
  }, [anchorKey, schedule.combineAnchors, schedule.id, entityOptions?.arms])
}
